import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { UserService } from "../services/user/user.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private userService: UserService) {}

  canActivate(): boolean | UrlTree {
    if (this.userService.userIsLogged()) {
      return true;
    }

    return this.router.createUrlTree(["/login"]);
  }
}
